var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"m-bottom"},[_c('a',{attrs:{"href":_vm.homepage,"target":"_blank"}},[_vm._v("© JX3BOX.COM")]),_c('a',{staticClass:"u-feedback",attrs:{"href":_vm.feedback,"target":"_blank"}},[_vm._v("❤ Help")])])}
var staticRenderFns = []

export { render, staticRenderFns }